'use client';

import { useContext } from 'react';

import { TranslationsContext } from '@/context/Translations';
import { _t } from '@/lib/i18n';

export const useTranslation = () => {
  const translations = useContext(TranslationsContext);

  const t = (key: string, options?: { [key: string]: number | string }) => {
    if (!translations) {
      return key;
    }
    return _t(key, translations, options);
  };

  return { t, isLoading: !translations };
};
